import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12 23.27L3 16.27L4.62 15.01L11.99 20.74L19.37 15.001L21 16.27L12 23.27ZM12 19L3 12L4.62 10.74L11.99 16.47L19.37 10.73L21 12L12 19ZM12 14.73L4.63 8.99998L3 7.72998L12 0.72998L21 7.72998L19.36 8.99998L12 14.73Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "LayersAlt"
);
